// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Pervasives from "rescript/lib/es6/pervasives.js";

function findIndexOf(arr, x) {
  var i = arr.findIndex(function (x$p) {
        return x$p === x;
      });
  if (i !== -1) {
    return i;
  } else {
    return Pervasives.failwith("Unable to find `" + x + "` in array `" + arr + "`");
  }
}

function insert(arr, value, place) {
  var arr$1 = arr.slice();
  arr$1.splice(typeof place === "object" ? findIndexOf(arr$1, place.VAL) : arr$1.length, 0, value);
  return arr$1;
}

function reinsert(arr, value, place) {
  var arr$1 = arr.slice();
  var from = findIndexOf(arr$1, value);
  arr$1.splice(from, 1);
  arr$1.splice(typeof place === "object" ? findIndexOf(arr$1, place.VAL) : arr$1.length, 0, value);
  return arr$1;
}

export {
  findIndexOf ,
  insert ,
  reinsert ,
  
}
/* No side effect */
